import { render, staticRenderFns } from "./formlayout.vue?vue&type=template&id=1b711817"
import script from "./formlayout.vue?vue&type=script&lang=js"
export * from "./formlayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports